import { withInstall } from '@tw-element/utils'

import Tag from './src/tag.vue'

export const TwTag = withInstall(Tag)
export default TwTag

export * from './src/tag'
